import { CSSProperties, FC } from "react";
import './styles.css';
 
const paragrafo: CSSProperties = {
    marginBottom: "12pt",
};

const listaReentrega: CSSProperties = {
    marginTop: 0,
    marginBottom: 0
};

const itemReentrega: CSSProperties = {
    margin: 0,
    paddingBottom: "3pt",
    lineHeight: 1,
};

const motivosReentrega: string[] = [
    "Fornecimento de endereço incorreto ou incompleto;",
    "Ausência injustificada no local no período previamente agendado;",
    "Recusa injustificada de recebimento;",
    "Solicitação de reagendamento após a programação da entrega;",
    "Restrições de acesso ao local não informadas previamente;",
    "Ausência de cadastro, autorização ou agendamento exigido para acesso ao local;",
    "Impossibilidade de acesso do veículo de transporte em razão de condições ou limitações não informadas previamente.",
];

const PrazoEntregaProdutos: FC = () => {
    return <>
        <div className="title">Prazo de entrega de produtos</div>

        <div className="default-text-list"><span>O prazo médio de entrega pode variar conforme:</span></div>
        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Financiamento direto (via Plataforma): aprovação da instituição financeira após apresentação e análise de todos os documentos relacionados ao financiamento, conforme os procedimentos e prazos internos;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Financiamento indireto (demais instituições): pagamento total da instituição financeira para a Intelbras;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Motivos de força maior que venham a interferir, direta ou indiretamente no pedido, expedição e/ou transporte do produto.</div>
            </div>
        </div>

        <div className="sub-title-minor">Acompanhamento da entrega</div>

        <div className="default-text-list"><span>Para o cliente acompanhar o status do seu pedido, basta informar seu e-mail e senha, criados através do link de pagamento, na Plataforma Solar.</span></div>

        <div className="default-text-list" style={{ marginTop: "12pt", marginBottom: "8pt" }}><span>Todos os serviços decorrentes desta proposta deverão ser agendados diretamente com a Revenda. Ao receber o instalador, o cliente deve acompanhar o serviço e assinar a Ordem de Serviço somente após a conclusão dos serviços de instalação.</span></div>
    
        <div className="sub-title-minor">Entrega</div>
 
        <div className="default-text-list" style={paragrafo}><span>A entrega do produto será previamente agendada entre a transportadora e o cliente, em data e período informados com antecedência. As entregas ocorrerão em dias úteis e em horário comercial, salvo condição distinta previamente acordada entre a transportadora e o cliente.</span></div>
 
        <div className="default-text-list" style={paragrafo}><span>É responsabilidade do cliente, da Revenda ou Distribuidor, conforme aplicável, informar previamente todas as condições que possam impactar a realização da entrega, incluindo restrições de acesso, horários permitidos, necessidade de cadastro, autorização ou agendamento, regras de condomínios, limitações para circulação ou estacionamento de veículos de carga, condições de acesso a propriedades rurais ou outras particularidades do local.</span></div>
 
        <div className="default-text-list" style={paragrafo}><span>O cliente deverá garantir, na data e período previamente agendados, a presença de pessoa maior de idade e autorizada para receber e conferir a mercadoria e assinar o comprovante de entrega, bem como assegurar condições adequadas e seguras para acesso ao local.</span></div>
 
        <div className="default-text-list" style={paragrafo}><span>Será realizada 01 (uma) tentativa de entrega no endereço indicado pelo cliente, sem custos adicionais. Caso a entrega não se concretize por culpa exclusiva do consumidor, devidamente caracterizada, como, exemplificativamente:</span></div>
 
        <div className="default-text-list" style={paragrafo}>
            <ul style={listaReentrega}>
                {motivosReentrega.map((motivo) => (
                    <li key={motivo} className="default-text-list" style={itemReentrega}>
                        <span>{motivo}</span>
                    </li>
                ))}
            </ul>
        </div>
    </>
}

export const PrazoEntregaProdutosContinuacao: FC = () => {
    return <>
        <div className="default-text-list" style={paragrafo}><span>Nessas situações, poderá ser necessário o reagendamento da entrega, hipótese em que os custos adicionais de reentrega, armazenagem e demais despesas logísticas decorrentes da ocorrência poderão ser repassadas ao cliente ou à Revenda, e estão sujeitas a reanálise pela Intelbras.</span></div>

        <div className="default-text-list" style={paragrafo}><span>No ato da entrega, o cliente ou a pessoa autorizada deverá conferir a quantidade de volumes e as condições aparentes das mercadorias e embalagens, verificando eventuais sinais de avaria, violação ou divergência.</span></div>
 
        <div className="default-text-list" style={paragrafo}><span>Caso seja identificada qualquer não conformidade ou ocorrência durante a entrega, esta deverá obrigatoriamente ser registrada no CT-e (Conhecimento de Transporte Eletrônico), no campo destinado às ressalvas do recebimento, antes da conclusão da entrega.</span></div>
 
        <div className="default-text-list" style={paragrafo}><span>Devem ser registradas no CT-e todas as ocorrências relacionadas à entrega, incluindo, mas não se limitando a: avarias aparentes, embalagens violadas, falta ou divergência de volumes, recusa ou impossibilidade de aguardar a conferência da mercadoria pelo responsável pelo recebimento, danos causados pelo veículo ou motorista no local da entrega, solicitação de valores ou cobranças não previstas para descarga, dificuldades ou irregularidades na realização da entrega, bem como qualquer outra situação considerada divergente das condições previstas para o atendimento.</span></div>
 
        <div className="default-text-list" style={paragrafo}><span>O registro deverá ser realizado exclusivamente no CT-e, não sendo considerado, para essa finalidade, o apontamento realizado somente na Nota Fiscal, em documentos distintos ou por outros meios. Sempre que possível, a ocorrência deverá também ser acompanhada de registros fotográficos e comunicada imediatamente à Revenda.</span></div>
 
        <div className="default-text-list" style={paragrafo}><span>A conferência no momento do recebimento deverá contemplar a quantidade de volumes e as condições aparentes da mercadoria e das embalagens. Caso o motorista não aguarde ou impossibilite a realização da conferência, essa ocorrência também deverá ser expressamente registrada no CT-e.</span></div>
    </>
}

export default PrazoEntregaProdutos;